module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/CPU#2-207ebf10b57fd62a84864e41319aef74.svg";